/**
 * Simple but not robust implement of React18 experimental hook `useEffectEvent`,
 *   to keep compatible with other React versions.
 *
 * for some more robust implements, you can see:
 * - `useEvent` in https://github.com/scottrippey/react-use-event-hook
 * - `useMemoizedFn` in https://github.com/alibaba/hooks
 */
import { useMemo, useRef } from 'react';
export var useEffectEvent = function useEffectEvent(callback) {
  var callbackRef = useRef(callback);
  /**
   * same as modify ref value in `useEffect`, use for avoid tear of layout update
   */

  callbackRef.current = useMemo(function () {
    return callback;
  }, [callback]);
  var stableRef = useRef(); // init once

  if (!stableRef.current) {
    stableRef.current = function () {
      var _a;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.apply(this, args);
    };
  }

  return stableRef.current;
};